import React from 'react';
import InsightMaster from './InsightMaster';

function ColorsMaster() {
  return (
    <InsightMaster
      title="Colors"
      modalTitle="Color"
      addButtonText="Add Color"
      searchPlaceholder="Search colors..."
      nameLabel="Name *"
      namePlaceholder="Color code / color name"
      itemType="COLOR"
      hasColorField
    />
  );
}

export default ColorsMaster;
